import React from "react";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Box, TextField, Typography } from "@mui/material";
import { useDrag } from "react-dnd";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import { ComponentProps, DragType } from "../utils/types";

const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.light,
    width: "100%",
    padding: 8,
    marginBottom: 8,
  },

  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const StyledDragIndicatorIcon = withStyles(DragIndicatorIcon, (theme) => ({
  root: {
    color: colors.gray,
  },
}));

const LongText: React.FC<ComponentProps> = ({ componentType }) => {
  const [, drag] = useDrag({
    type: DragType.COMPONENT,
    item: () => {
      return componentType;
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const { classes } = useStyles();

  return (
    <div className={classes.root} ref={drag}>
      <Box className={classes.header}>
        <Typography
          variant="h6"
          color="textPrimary"
          style={{ marginBottom: 12 }}
        >
          Long text input
        </Typography>
        <StyledDragIndicatorIcon />
      </Box>

      <TextField placeholder="Enter long text input" />
    </div>
  );
};

export default LongText;
